<template>
  <v-row style="display: grid; grid-template-columns: 52.9% 47.1%;">
    <v-col class="px-0">
      <v-card-title class="px-0">
        <v-text-field
            class="quickSearch pa-1"
            v-on:keyup.enter="tableModel.quickSearch(quickSearchText)"
            v-model="quickSearchText"
            prepend-inner-icon="mdi-magnify"
            :label="$t('Поиск')"
            single-line
            hide-details
            variant="solo"
        ></v-text-field>
      </v-card-title>
    </v-col>

    <v-col class="actionsMenu pr-0">
      <v-card-title class="pa-0" style="max-height: 60px">
        <v-btn color="primary" @click="tableModel.quickSearch(quickSearchText)">
          <v-icon icon="mdi-magnify"></v-icon>{{ $t('Найти') }}</v-btn>
      </v-card-title>
      <v-card-title class="pr-0 py-0 ml-auto">
        <v-btn color="primary" @click="createAction()">
          {{ $t(this.isUser ? 'Создать пользователя' : 'Создать организацию')}}
        </v-btn>
      </v-card-title>
    </v-col>
  </v-row>
</template>

<script>
import api from '@/api';
import { toast } from '@/lib/toast';

export default {
  name: 'adminDataTable',
  props: {
    tableModel: {
      Object,
      required: true,
    },
    isUser: {
      Boolean,
      required: true,
    },
    createAction: {
      Function,
      required: true,
    }
  },
  data() {
    return {
      quickSearchText: '',
      page: 1,
      pageCount: 0,
      pageSizes: [
        { title: '10', value: 10 },
        { title: '25', value: 25 },
        { title: '50', value: 50 },
        { title: '100', value: 100 },
      ],
      totalEntries: -1
    }
  }
}
</script>

<style scoped>

.actionsMenu {
  display: flex;
  align-items: center;
  line-height: 44px;
  margin-bottom: 1px;
}

.quickSearch {
  min-height: 44px;
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--border-color)) !important;
  border-radius: 8px;
}

</style>